import { render, staticRenderFns } from "./RepairBase.vue?vue&type=template&id=4a13c781&scoped=true"
import script from "./RepairBase.vue?vue&type=script&lang=js"
export * from "./RepairBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a13c781",
  null
  
)

export default component.exports